<template>
  <van-overlay v-if="list && list[listIndex].logo" z-index="999" :show="show" @click="show = false">
    <div class="wrapper flex-col" @click.stop>
      <div class="flex items-center justify-center posr">
        <div class="flex flex-col items-center justify-center">
          <img
            class="max-w-[540px] max-h-[540px] w-[80vw] h-[80vw] mb-[20px]"
            :src="list[listIndex].logo"
            alt=""
            @click="handelUrl(list[listIndex].href)"
          />
        </div>
        <van-icon
          size="26px"
          name="clear"
          class="posa top-[0px] right-0 bg-[#fff] rounded-[50%]"
          @click="handelgb"
        />
      </div>
    </div>
  </van-overlay>
</template>

<script setup>
import { ref } from 'vue'
// const { ref } = window.Vue
const show = ref(true)
const listIndex = ref(0)
const props = defineProps({
  list: {
    type: Array,
    default: () => []
  }
})
const emits = defineEmits(['close'])
const handelgb = () => {
  if (listIndex.value == props.list.length - 1) {
    // const tc = sessionStorage.getItem('tc')
    // if (!tc) {
    // emits('close')
    //   sessionStorage.setItem('tc', true)
    // }
    emits('close')
    show.value = false
  } else {
    listIndex.value++
  }
}
const handelUrl = (url) => {
  window.open(url, '_blank')
}
</script>

<style scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
